import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator, displayBrandSliderOnLoad} from './components/sliders.js';
import { showMoreFaqs, accordion } from './components/accordion.js';
import { videoLazyLoading } from './components/video.js'
import { toggleRedirectBanner } from './components/redirect-banner.js';
import { initSlickSlider, initFeaturesContentLinks } from './components/rebranding-bar.js';

document.addEventListener("DOMContentLoaded", async function () {
  await slickSliderGenerator('brand', '.logos-container');
  await slickSliderGenerator('testimonials', '.testimonials-container');
  await slickSliderGenerator('features', '.features-container');
  initSlickSlider('.contents-mobile', {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false
  });
  displayBrandSliderOnLoad();
  accordion('.faqs-cards');
  showMoreFaqs();
  getSVG();
  videoLazyLoading();
  toggleRedirectBanner();
  setTimeout(initFeaturesContentLinks, 300);
});
